import React from "react"
import Plot from "../components/plotly"

const DeathChart = ({
  positiveCasePercent,
  negativeCasePercent,
  positiveCase,
  negativeCase,
}) => {
  return (
    <Plot
      data={[
        { ...positiveCasePercent, opacity: 0.4 },
        { ...negativeCasePercent, opacity: 0.4 },
        { ...negativeCase, yaxis: "y2" },
        { ...positiveCase, yaxis: "y2" },
      ]}
      layout={{
        showlegend: true,
        legend: {
          orientation: "h",
          yanchor: "bottom",
          xanchor: "left",
          y: -0.2,
        },
        barmode: "stack",
        xaxis: { fixedRange: true, type: "date" },
        yaxis: {
          fixedRange: true,
          title: "Cases",
          side: "left",
        },
        yaxis2: {
          overlaying: "y",
          fixedRange: true,
          side: "right",
          title: "Counts",
        },
      }}
      onClick={event => console.log(event)}
      onSelected={event => console.log(event)}
    />
  )
}

export default DeathChart
